import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import Button from '../../components/Button';
import JobSingleList from './components/JobSingleList';
import Pagination from '../../components/Pagination';
import CountDisplay from '../../components/CountDisplay';
import Loader from '../../components/Loader';
import user from '../../store/user';
import './JobParser.scss';
import { ToastContainer, toast } from 'react-toastify';
import { Tab, Table, TableBody, TableHeader, TableRow } from 'semantic-ui-react';
import InputBox from '../../components/InputBox';
import { adminFeatureMapping } from '../../models/adminFeatureMapping';
import { getQueryParams } from '../../utils/utilFunctions';
import getBulkJobUpload from '../../services/getBulkJobUpload'
import submitBulkJobUpload from '../../services/submitBulkJobUpload.js';
import BulkJobUploadModal from './components/BulkJobUploadModal';

const JobParser = (props) => {
  const [status, setStatus] = useState();
  const [JobListData, setJobListData] = useState([]);
  const pageContent = 20;
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [count, setTotalCount] = useState('');
  const [adminId, setAdminId] = useState('');
  const [adminEmail, setAdminEmail] = useState('');  
  const [executeAccess, setExecuteAcess] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

  useEffect(() => {
    async function fetchUserData() {
      const userDetails = await user.getProfile();
      const adminIdData = userDetails.id;
      const adminEmail = userDetails.email;
      
      if(!process.env.REACT_APP_BULK_JOB_UPLOAD_ACCESS_EMAILS || !process.env.REACT_APP_BULK_JOB_UPLOAD_ACCESS_EMAILS.includes(adminEmail)){
        window.location.href = '/notAdmin';
        return;
      }

      setAdminId(adminIdData);
      setAdminEmail(adminEmail);

      const queryParams = getQueryParams(props.location.search || '');
      const params = {
        pageNumber: pageNumber,
        pageContent: pageContent,
        status,
      };

      // check if query params has a status value
      if (queryParams) {
        if (queryParams.search) {
            const searchValue = decodeURI(queryParams.search);
            setSearchText(searchValue);
            params.id = searchValue;
        }

        if (queryParams.status) {
            setStatus(queryParams.status);
            params.status = queryParams.status;
        }

        if (queryParams.pg) {
          setPageNumber(queryParams.pg);
          params.pageNumber = queryParams.pg;
        }

      }

      if (
        user.checkFeatureAccess(adminFeatureMapping.COMPANY_MGT)
      ) {
        setExecuteAcess(true);
      }
     
      setJobListDataFromApi(adminIdData, params);
    }
    fetchUserData();
  }, []);

  /**
   * update query params, accepts an object
   * note that always send an object event if there are no keys since 
   * we are destructuring object in function arguments
   */
  const updateQueryParams = ({ filterStatus = null, handleClear = false, page = null }) => {
    const arr = [];
    const selectedStatus = filterStatus !== null ? filterStatus : status;
    const search = handleClear ? null : searchText ? searchText : null;  

    if (selectedStatus !== '') {
        arr.push(`status=${selectedStatus}`);
    }

    if (search) {
        arr.push(`search=${search}`);
    }

    if (page || page == 0) {
      arr.push(`pg=${page}`);
    }

    props.history.push(`${props.location.pathname}${arr.length ? '?' + arr.join('&') : ''}`);
  }

  const handleFilterChange = event => {
    selectJobStatus(event.target.value);
    updateQueryParams({ filterStatus: event.target.value });
  }

  async function selectJobStatus(value) {
    setStatus(value);
    setPageNumber(1);
    setIsLoading(true);
    var params = getParams();
    params.status = Number(value);
    params.pageNumber=1;
    setJobListDataFromApi(adminId, params);
  }

  function getParams() {
    var params = {
        pageNumber: pageNumber,
        pageContent: pageContent,
    };

    if (status !== undefined && status !== '') {
        params.status = status;
    }

    if (searchText) {
        params.createdBy = searchText;
    }
    return params;
  }

  async function setJobListDataFromApi(adminIdData = '', params) {
    if (adminId != '') adminIdData = adminId;

    let jobData = await getBulkJobUpload(adminIdData, params);
    if( !jobData || !jobData.data || !jobData.data.data) {
      setJobListData([]);
      setTotalCount(0);
    }
    else{
    setJobListData(jobData.data.data || []);
    setTotalCount(parseInt(jobData.data.count));
    }
    setIsLoading(false);
    setIsPageLoading(false);
  }

  async function handlePageChange(receivedPageNumber) {
    setPageNumber(receivedPageNumber);
    setIsPageLoading(true);
    var params = getParams();
    params.pageNumber = receivedPageNumber;
    setJobListDataFromApi(adminId, params);

    // update query params to add page number
    updateQueryParams({ page: receivedPageNumber });
  }


  function onChangeSearch(ev) {
    if (ev.key === 'Enter') {
      setPageNumber(1);
      var params = getParams();
      params.pageNumber = 1;
      setIsLoading(true);
      setJobListDataFromApi(adminId, params);
      return;
    }
    setSearchText(ev.target.value);
  }
  function detectEnter(ev) {
    if (ev.key === 'Enter') {
      setPageNumber(1);
      var params = getParams();
      params.pageNumber = 1;
      setIsLoading(true);
      setJobListDataFromApi(adminId, params);
      updateQueryParams({});
      return;
    }
  }

  async function onClickClear() {
    setSearchText('');
    setPageNumber(1);
    setIsLoading(true);
    setStatus('') // Set to empty string instead of 2
    var params = {
        pageNumber: 1,
        pageContent: pageContent,
    };
    updateQueryParams({ handleClear: true });
    setJobListDataFromApi(adminId, params);
  }

  const handleBulkUpload = async (formData) => {
    try {
      // Add your API call here to submit the form
      await submitBulkJobUpload(adminId, formData);
      toast.success('Bulk job upload initiated successfully');
      setShowBulkUploadModal(false);
      // Refresh the job list
      setJobListDataFromApi(adminId, getParams());
    } catch (error) {
      
      toast.error('Failed to upload bulk jobs. Please try again.');
    }
  };

  return (
      <div>
          <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
      />
          <div className="row">
              <div className="heading inlineElement">Select Status :</div>
              <div className="inlineElement">
                  <select value={status} onChange={handleFilterChange}>
                    <option name="status" value="">All</option>
                    <option name="status" value="0">Pending</option>
                    <option name="status" value="1">Processing</option>
                    <option name="status" value="2">Completed</option>
                    <option name="status" value="3">Rejected</option>
                </select>
              </div>
              {executeAccess ? (
                  <Button
            skin="dark"
            text="Add New Bulk Job"
            clickButton={() => setShowBulkUploadModal(true)}
          />
        ) : null}

              <div
          className="right"
          style={{ display: 'flex', alignItems: 'baseline' }}
        >
                  <InputBox
            placeholder="Enter Admin ID"
            value={searchText}
            onChange={onChangeSearch}
            onKeyPress={detectEnter}
          />
                  <Button
            className="search-btn"
            skin="dark"
            disabled={false}
            text="Search"
            clickButton={() => {
              var params = getParams();
              setJobListDataFromApi(adminId, params);
              updateQueryParams({});
            }}
          />
                  <Button
            skin="light"
            disabled={false}
            text="Clear"
            clickButton={onClickClear}
          ></Button>
              </div>
          </div>
          <br />

          <br />
          <div className="centerAlign">
              <div className="paginationManagement">
                  <Pagination
            totalItemsCount={count}
            content={pageContent}
            pageNumber={pageNumber}
            handlePageChange={handlePageChange}
          />
              </div>
              <div className="countDisplayManagement">
                  <CountDisplay
            start={(pageNumber - 1) * pageContent + 1}
            end={pageNumber * pageContent}
            total={count}
          />
              </div>
          </div>

          {
            isLoading ? <Loader /> : (
                <>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <Table.HeaderCell width={1} className="centerAlignManagemnetTable">
              ID
                                </Table.HeaderCell>
                                <Table.HeaderCell width={2} className="centerAlignManagemnetTable">
              Recruiter Email
                                </Table.HeaderCell>
                                 <Table.HeaderCell width={2} className="centerAlignManagemnetTable">
              Admin Email
                                </Table.HeaderCell>
                                 <Table.HeaderCell width={1} className="centerAlignManagemnetTable">
              Created At
                                </Table.HeaderCell>
                                <Table.HeaderCell width={2} className="centerAlignManagemnetTable">
              Status
                                </Table.HeaderCell>
                                <Table.HeaderCell width={1} className="centerAlignManagemnetTable">
              Job IDs
                                </Table.HeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {
                                isPageLoading ? (
                                    <Table.Row>
                                        <Table.Cell colSpan={8}>
                                            <Loader />
                                        </Table.Cell>
                                    </Table.Row>
                                ) : JobListData.map((job, index) => {
                                    return (!status || job.status == status) ? (
                                        <JobSingleList
                                            key={index}
                                            data={job}
                                            executeAccess={executeAccess}
                                            adminId={adminId}
                                            adminEmail={adminEmail}
                                        />
                                    ) : null;
                                })}
                        </TableBody>
                    </Table>
                    <div className="centerAlign">
                        <div className="paginationManagement">
                            <Pagination
                              totalItemsCount={count}
                              content={pageContent}
                              pageNumber={pageNumber}
                              handlePageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </>
            )
          }
          <BulkJobUploadModal
            show={showBulkUploadModal}
            onClose={() => setShowBulkUploadModal(false)}
            onSubmit={handleBulkUpload}
            adminId={adminId}
          />
      </div>
  );
};

export default withRouter(JobParser);
